import { fill } from '../creatives/format'

export function money(n: number, decimals = 0): string {
  return '$' + n.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
}

export function num(n: number): string {
  return n.toLocaleString('en-US')
}

/** The dictionary's substitution, counted words included: one implementation, in `fill`. */
export function fmt(template: string, vars: Record<string, string | number>): string {
  return fill(template, vars)
}
